import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/loyalty-points";
const options = { role: ROLE.RESTAURANT };

export const configureLoyaltyPoints = async (values) => {
  return await axiosInstance(options).post(`${path}/configure-loyalty-points`, values);
}

export const getLoyaltyPointsConfiguration = async () => {
  return await axiosInstance(options).post(`${path}/get-loyalty-points-configuration`, {});
}

export const getLoyaltyList = async (data) => {
  return await axiosInstance(options).post(`${path}/list`, data);
}